import {makeAutoObservable, observable, action} from "mobx";

class LoadingStore {
    constructor() {
        makeAutoObservable(this);
    }

    @observable
    requestCnt = 0;

    @action
    increaseCount() {
        ++this.requestCnt;
    }

    @action
    decreaseCount() {
        if(this.requestCnt > 0)
            --this.requestCnt;
    }
}

const loadingStore = new LoadingStore();

export default loadingStore;